import React from 'react';
const IconActionInsert = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 4H3V6H17V4Z" fill="#2D2E2E"/>
<path d="M13 9H3V11H13V9Z" fill="#2D2E2E"/>
<path d="M9 14H3V16H9V14Z" fill="#2D2E2E"/>
<path d="M17 14V10H15V14H11V16H15V20H17V16H21V14H17Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconActionInsert;